<onboarding-container
  [buttonLabel]="'onboarding.provision.button-label' | transloco"
  [formValid]="(facade.sendingProvisionInformation$ | async) !== true"
  [loading]="facade.sendingProvisionInformation$ | async"
  (back)="facade.goToPreviousStep()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'onboarding.provision.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.provision.text' | transloco }}</p>
  <div class="mt-4 zero-surface grey-800 p-3">
    <p class="zero-text p-base-bold">{{ 'onboarding.provision.info-box.headline' | transloco }}</p>
    <p class="zero-text p-base-reg">{{ 'onboarding.provision.info-box.text' | transloco }}</p>
    <p class="zero-text p-base-bold">{{ 'onboarding.provision.info-box.consent' | transloco }}</p>
    <ul>
      <li>{{ 'onboarding.provision.info-box.first' | transloco }}</li>
      <li>{{ 'onboarding.provision.info-box.second' | transloco }}</li>
    </ul>
    @if (onboardingClientConfigService.config$ | async; as clientConf) {
      <div class="mb-2">
        <a class="zero-text link" (click)="showAgreement1 = !showAgreement1">
          {{ 'onboarding.provision.info-box.donau-capital' | transloco }}
        </a>
        @if (showAgreement1) {
          <div class="mt-3" [innerHTML]="clientConf.contractExcerpt1"></div>
        }
      </div>
      <div>
        <a class="zero-text link" (click)="showAgreement2 = !showAgreement2">
          {{ 'onboarding.provision.info-box.baader' | transloco }}
        </a>
        @if (showAgreement2) {
          <div class="mt-3" [innerHTML]="clientConf.contractExcerpt2"></div>
        }
      </div>
    }
  </div>
  <div class="mt-4 zero-surface grey-800 p-3">
    <div class="zero-text p-base-reg">{{ 'onboarding.provision.info-box-2.text' | transloco }}</div>
  </div>
</onboarding-container>
